import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";

const notificationsOwnUrlApi = environment.notificationsOwnUrlApi;
const notificationsMarkReadedUrlApi = environment.notificationsMarkReadedUrlApi;

@Injectable()
export class NotificationService {
  constructor(private http: HttpClient) {}

  getNotifications() {
    return this.http
      .request("GET", `${notificationsOwnUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  markNotificationAsReaded(id: number) {
    // const body = { id: id };
    return (
      this.http
        // .request("PUT", `${notificationsMarkReadedUrlApi}`, { body })
        .request("PUT", `${notificationsMarkReadedUrlApi}/` + id)
        .pipe(map((resp: any) => resp))
    );
  }
}
